export enum LabelType {
    TempSense = 'tempSense',
    HumiditySense = 'humiditySense'
}

export const SenseType = {
    TempSense: 'tempSense',
    HumiditySense: 'humiditySense'
} as const

export enum UnitTypes {
    Temperature = 'temperature',
    Humidity = 'humidity',
    Battery = 'battery',
    Label = 'label'
}

export enum UnitTypeIcons {
    Temperature = 'temperature',
    Humidity = 'drop'
}

export enum TimeUnit {
    Seconds = 's',
    Minutes = 'm',
    Hours = 'h'
}

export enum TemperatureUnit {
    Celsius = 'c',
    Fahrenheit = 'f'
}
